import classNames from 'classnames';
import { range } from 'lodash';

import { ReactComponent as EmptyStar } from '../../../../../assets/images/progressStars/star-0.svg';
import { ReactComponent as FilledStar } from '../../../../../assets/images/progressStars/star-100.svg';
import { Props as CancellationStepsProps } from '../CancellationSteps';

export interface Props extends Pick<CancellationStepsProps, 'setCancelSelection'> {
  rating: number;
  labelClassName?: string;
}

const CancelRating = ({ rating, setCancelSelection, labelClassName }: Props) => {
  const onStarClick = (index: number) => setCancelSelection((current) => ({ ...current, rating: index }));

  return (
    <div className="flex flex-col gap-y-2">
      <p className={classNames('text-center text-lg font-bold', labelClassName)}>Rate your experience with Cluey</p>
      <div className="my-5 flex min-h-[42px] justify-center gap-x-5">
        {range(5).map((index) => (
          <button key={`star-${index + 1}`} onClick={() => onStarClick(index + 1)} type="button">
            {index + 1 <= rating ? <FilledStar /> : <EmptyStar />}
          </button>
        ))}
      </div>
    </div>
  );
};

export default CancelRating;
